import React from 'react'
import PropTypes from 'prop-types'
import {AppProvider, Frame, Page, Button, Toast} from "@shopify/polaris";
import translations from '@shopify/polaris/locales/es.json';
const propTypes={
  messages: PropTypes.array.isRequired
}


class FlashMessage extends React.Component{
  constructor(props) {
    super(props)
    this.state = {
      showToast: props.messages.length > 0 ? true : false,
      error_msj: props.messages
    }
  }
  toggleToast = () => {
    this.setState(({showToast}) => ({showToast: !showToast}));
  };
  render(){
    // console.log(this.props)
    // console.log(this.state)
    const toastMarkup = this.state.showToast ? (
        this.state.error_msj.map(e=>{
          return <Toast
              key={e.id}
              content={e.message}
              onDismiss={this.toggleToast}
              error={e.type=="success" || e.type == "notice" ? false : true}
          />
        })
    ) : null;
    return(
        <div className="flash_message" style={{height:"1px"}}>
          <AppProvider i18n={translations}>
            <Frame>
              <Page >
                {toastMarkup}
              </Page>
            </Frame>
          </AppProvider>
        </div>
    )
  }
}
FlashMessage.propTypes= propTypes


export default FlashMessage